<header>
	<div class="container">
		<div class="row">
			<div class="col-md-3">
				<img src="assets/img/logo.svg" class="logo-header">
			</div>			
			<div class="col-md-4 offset-md-4 mt-2 text-start">
				<div *ngIf="login">
					<!--<h2>WELCOME:</h2>--><span> {{ nombres }} ({{ perfil }})</span>
					<br>
					<button class="btn red mb-2"
                   			(click)="logout()">
                    		<span>Cerrar sesion</span><span class="btn-arrow"></span>
                	</button>
				</div>
			</div>
		</div>
	</div>
</header>
